import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,message    } from 'antd';
import { render } from 'react-dom';
import { withScriptjs } from 'react-google-maps';

import Axios from "axios";
import GoogleMap from "../../GoogleMap"; 

const buttonWidth = 70;
const { TextArea } = Input;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			name: '',
			details: '',
  		    iconLoading: false,
			location:'',
			dragging:false,
			is_open_map:0,
			oc_lattitude:'17.3850',
			oc_longitude:'78.4867'
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		   var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		   this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id']});
		}
		window.getGoogleMap = (lat,lng) => {
			this.setState({
				is_open_map:0
			});			
			setTimeout(() => {
				this.setState({
					is_open_map:1,
					oc_lattitude: lat,
					oc_longitude: lng,
				});
			}, 500);
		}
		this.checkLocation();
	}
	
	checkLocation=()=>{
		setTimeout(() => {
			if(document.getElementById('search_location_2')){
				const $ = window.$;
				const google = window.google;
				var geocoder;
				var map;
				var marker;
				var autocomplete;
				if(document.getElementById('search_location_2')){
					var search_location_2=document.getElementById('search_location_2');
				}
				else{
					var search_location_2= '';
				}		
				function get_location() {
					autocomplete = new google.maps.places.Autocomplete(
					(document.getElementById('search_location_2')),
					{ types: ['geocode'] });
					window.google.maps.event.addListener(search_location_2, 'place_changed', function() {
					});
				}
				
				if(document.getElementById('search_location_2')){
					var lat = '';
					var lng = '';
					
					if(document.getElementById('search_location_2')){
					   var input = document.getElementById('search_location_2');
					   var autocomplete = new google.maps.places.Autocomplete(input);
						google.maps.event.addListener(autocomplete, 'place_changed', function () {
							var place = autocomplete.getPlace();
							var lat  = place.geometry.location.lat();
							var lng = place.geometry.location.lng();
							document.getElementById('search_latitude_2').value = place.geometry.location.lat();
							document.getElementById('search_longitude_2').value = place.geometry.location.lng();
							document.getElementById('search_addr_2').value = place.formatted_address;
							window.getGoogleMap(lat,lng);
							initialize(lat,lng);
						});
					}
					initialize(lat,lng);
					function initialize(lat,lng) {
						if(document.getElementById('search_latitude_2')){
							var initialLat = document.getElementById('search_latitude_2').value
						}
						if(document.getElementById('search_longitude_2')){
							var initialLong = document.getElementById('search_longitude_2').value
						}
						if(lat==''){
							initialLat = initialLat?initialLat:17.3850;
							initialLong = initialLong?initialLong:78.4867;
						}
						else{
							initialLat = lat;
							initialLong = lng;
						}
						var latlng = new google.maps.LatLng(initialLat, initialLong);
						var options = {
							zoom: 16,
							center: latlng,
							mapTypeId: google.maps.MapTypeId.ROADMAP
						};
						map = new google.maps.Map(document.getElementById("geomap"), options);
						geocoder = new google.maps.Geocoder();
						marker = new google.maps.Marker({
							map: map,
							draggable: true,
							position: latlng
						});
						window.google.maps.event.addListener(marker, "dragend", function () {
							var point = marker.getPosition();
							map.panTo(point);
							geocoder.geocode({'latLng': marker.getPosition()}, function (results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									map.setCenter(results[0].geometry.location);
									marker.setPosition(results[0].geometry.location);
									document.getElementById('search_addr_2').value=results[0].formatted_address;
									document.getElementById('search_latitude_2').value=marker.getPosition().lat();
									document.getElementById('search_longitude_2').value=marker.getPosition().lng();
									window.getGoogleMap(marker.getPosition().lat(),marker.getPosition().lng());
								}
							});
						});
					}
				}
				
			}
		}, 1000);
	}
	
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var location = document.getElementById('search_location_2').value;
		var latitude = document.getElementById('search_latitude_2').value;
		var longitude = document.getElementById('search_longitude_2').value;
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			name : this.state.name,
			details : this.state.details,
			location : location,
			latitude : latitude,
			longitude : longitude,
		}
		getData('Transport/add_stop',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
				//document.getElementsByName(result.error_name)[0].classList.add("error_focus");
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Stop Added',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				window.location.href = '/transport-setup/manage-route/stop';
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

	}
	
	
	handleSizeChange = e => {
        this.setState({ [e.target.name]: e.target.value });
	    if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	}
	
	reverseLookup = (lat, lng) => {	
		var app = {
			latitude: lat,
			longitude: lng
		} 
		getData('auth/place_reverse',app).then((result) => {
			if(result.status==200){
			   document.getElementById('search_location_2').value = result.data;
			   document.getElementById('search_addr_2').value = result.data;
			   this.setState({ location: result.data, dragging: false });
			}
		});
	};

	onMarkerDragEnd = (map) => {
		document.getElementById('search_latitude_2').value = map.center.lat();
		document.getElementById('search_longitude_2').value = map.center.lng();
		this.reverseLookup(map.center.lat(), map.center.lng());
	}; 
	
	handleDragging = () => {
		this.setState({ dragging: true });
		//this.refs.confirmGpsLocation.style.height = "44.7vh";
	};
  
  
	render()
	{				
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Stop
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/manage-route/stop`} class="router-link-active" target="_self">Manage Stop </a></li>
										<li class="breadcrumb-item"> Add Stop </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
				 <div class="row">
					  <div class="col-md-12 ex-padd">   
							<div class="row view-Profile child-profile view-Profile-mobile mg0">
							   <div class="col-md-4 mb-20 mt-10 card-content iq-card">
								  <section class="invoice-list-wrapper section food ">
									<div class="children mb-20 iq-card2 flow-root form-group">
									    <div class="row">
											<div class="col-md-12 no-padd">
												<div class="col m6 s12 mb-10">
													<label>Google Location * </label>
													<input type="text" id="search_location_2" name="oc_location" class="form-control"/>
													<input type="text" type="hidden" id="search_latitude_2" />
													<input type="text" type="hidden" id="search_longitude_2"  />
													<input type="text" type="hidden" id="search_addr_2" />
												</div>	
											</div>
										</div>
										<div class="row">
											<div class="col-md-12 no-padd">
												<div class="col m6 s12 mb-10">
													<label>Stop Name *</label>
													<input type="text" name="name" onChange={this.handleSizeChange}  />
												</div>	
											</div>
										</div>
										<div class="row">						
											<div class="col-md-12 no-padd">
												<div class="col m6 s12 mb-10">
													<label>Details</label>
													<TextArea rows={4} name="details" onChange={this.handleSizeChange} />
												</div>	
											</div>
										</div>
									</div> 
									<div class="col-md-6 meal mt-20 mb-20 pt-20 bt center">
										<Button className="ant-btn btn  btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
									</div>
									
								  </section>
							   </div>
							   <div class="col-md-8 mb-20 mt-10 card-content iq-card">
							     <div class="map_div" style={{height: window.innerHeight - 200}}>
									<GoogleMap
										reverseLookup={this.reverseLookup}
										onMarkerDragEnd={this.onMarkerDragEnd}
										handleDragging={this.handleDragging}
										oc_lattitude={this.state.oc_lattitude}
										oc_longitude={this.state.oc_longitude}
										is_open_map={this.state.is_open_map}
									/>
									
								 </div>
							   </div>
							   
							   <div class="content-overlay"></div>
							</div>
						</div>
				 </div>
             </div>
			</div>
		) 
	} 
}
export default Index;
